import { HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { map } from 'rxjs';
import { PaginationRawResponse, PaginationResponse } from '@binclusion/shared/interfaces';
interface BaseRawResponse {
  data: [];
  pagination: PaginationRawResponse;
  message: string;
  status: number;
}

export const paginationMapInterceptor: HttpInterceptorFn = (req, next) => {
  return next(req).pipe(map(response => {
    if(response instanceof HttpResponse && isRawApiResponse(response.body)) {
      return response.clone({
        body: {
          ...response.body,
          pagination: mapPaginationResponse(response.body.pagination),
        }
      })
    }
    return response;
  }));
};

function isRawApiResponse(body: unknown): body is BaseRawResponse {
  return (
    typeof body === 'object' &&
    body !== null &&
    'pagination' in body
  );
}
function mapPaginationResponse(raw: PaginationRawResponse): PaginationResponse {
  return {
    page: raw.page,
    pageSize: raw.max_items_page,
    totalPage: raw.total_page,
    totalItems: raw.total_items,
  };
}
